import { type Err } from '../CreateGroup/useCreateCampaignGroup'

import { useMutation } from '@percent/partner-dashboard/common/hooks/useMutation/useMutation'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type UseEditCampaignGroupProps = Readonly<{
  onEdited: () => void
  onError: (error: Err) => void
}>

export type UseEditCampaignGroupReturn = Readonly<{
  isLoading: boolean
  editGroup: (id: string, name: string) => void
}>

const defaultError: Err = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useEditCampaignGroup = ({ onEdited, onError }: UseEditCampaignGroupProps): UseEditCampaignGroupReturn => {
  const { workplaceGivingService } = useServices()

  const [{ isLoading }, { apiFunc: editCampaignGroup }] = useMutation(
    workplaceGivingService.editCampaignGroup,
    () => {
      onEdited()
    },
    error => {
      if (error) {
        onError(error.response?.data?.error ?? defaultError)
      }
    }
  )

  return {
    isLoading,
    editGroup: (id: string, name: string) => {
      editCampaignGroup({ id, name })
    }
  }
}
